/* Reuse configured colors; keep search/cart handlers and new-tab user gestures intact. */
(() => {
  if (window.terrorNavButtonsReady) return;
  window.terrorNavButtonsReady = true;
  const states = new WeakMap(), replay = new WeakSet(), timers = new Map();
  const selector = '.gt-sidebar-tool > a,.gt-sidebar-tool > data-island > a';
  function reset(button) {button.classList.remove('gt-tap-feedback');clearTimeout(timers.get(button));timers.delete(button);}
  document.addEventListener('pointerdown', e => {
    const button = e.target.closest(selector);
    if (!button || e.pointerType !== 'touch' || button.getAttribute('aria-disabled') === 'true') return;
    reset(button);states.set(button,{x:e.clientX,y:e.clientY,time:performance.now(),cancelled:false});
    button.classList.add('gt-tap-feedback');button.setAttribute('data-nav-pointer','');
  }, {capture:true,passive:true});
  document.addEventListener('pointermove', e => {
    document.querySelectorAll('.gt-tap-feedback').forEach(button => {
      const state=states.get(button);
      if(state&&Math.hypot(e.clientX-state.x,e.clientY-state.y)>8){state.cancelled=true;reset(button);}
    });
  }, {capture:true,passive:true});
  document.addEventListener('pointercancel', () => {
    document.querySelectorAll('.gt-tap-feedback').forEach(button=>{const state=states.get(button);if(state)state.cancelled=true;reset(button);});
  },{capture:true,passive:true});
  document.addEventListener('click', e => {
    const button=e.target.closest(selector);if(!button||replay.has(button)||e.detail===0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    const state=states.get(button);if(!state||performance.now()-state.time>1500)return;
    if(state.cancelled){e.preventDefault();e.stopImmediatePropagation();return;}
    const delay=Math.max(80,Math.min(300,Number(button.dataset.tapDelay||button.closest('[data-kind="brand"]')?.dataset.tapFeedback)||160));
    // A new tab must retain the original browser gesture. Its feedback starts
    // at pointerdown; same-tab links and native drawers can wait for the flash.
    if(button.target==='_blank'||button.hasAttribute('download')){timers.set(button,setTimeout(()=>reset(button),delay));return;}
    e.preventDefault();e.stopImmediatePropagation();
    if(timers.has(button))return;
    timers.set(button,setTimeout(()=>{
      timers.delete(button);if(!button.isConnected)return;
      replay.add(button);button.click();replay.delete(button);reset(button);states.delete(button);
    },delay));
  },{capture:true});
  document.addEventListener('keydown', e => {if(e.key==='Tab')document.querySelectorAll('[data-nav-pointer]').forEach(el=>el.removeAttribute('data-nav-pointer'));},{capture:true});
  addEventListener('pageshow',()=>document.querySelectorAll('.gt-tap-feedback').forEach(reset));
})();
